export class Weborder {
    webCommerce: WebCommerce = new WebCommerce();
    customPrice: CustomPrice = new CustomPrice();
    checkedOut: CheckedOut = new CheckedOut();
    b2bCommerce: B2bCommerce = new B2bCommerce();
    b2bCheckedOut: B2bCheckedOut = new B2bCheckedOut();
}

export class WebCommerce {
    cart: number = 0;
    storePickupCheckout: number = 0;
    homeDeliveryCheckouts: number = 0;
    total: number = 0;
    wishlist: number = 0;
}

export class CustomPrice {
    deleted: number = 0;
    inQueue: number = 0;
    responded: number = 0;
    total: number = 0;
}

export class CheckedOut {
    confirmed: number = 0;
    delivered: number = 0;
    inProcess: number = 0;
    pending: number = 0;
}

export class B2bCommerce {
    cart: number = 0;
    checkout: number = 0;
    total: number = 0;
    wishlist: number = 0;
}

export class B2bCheckedOut {
    confirmed: number = 0;
    delivered: number = 0;
    inProcess: number = 0;
    pending: number = 0;
}
